export default "__VITE_ASSET__DcXLsL3S__"